import React from 'react'
import { Link } from 'react-router-dom'
import usePortal from 'react-useportal'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faPen, faSignal, faSync } from '@fortawesome/free-solid-svg-icons'

import DeleteClientModal from './DeleteClientModal'

import ChangeStatusModal from './ChangeStatusModal'
import { ClientStatuses } from '../../../../../variables/constants'

const ClientDisplay = ({ id, firstName, lastName, nextStatuses, refreshList, status }) => {
    const {
        openPortal: openDeletePortal,
        closePortal: closeDeletePortal,
        isOpen: deletePortalIsOpen,
        Portal: DeletePortal,
    } = usePortal({
        bindTo: document && document.getElementById('modal-portal'),
        onOpen({ portal }) {
            portal.current.style.cssText = 'display: contents;'
        },
    })

    const clientStatusMap = ClientStatuses.reduce((o, c) => {
        o[c.key] = c.label
        return o
    }, {})

    const {
        openPortal: openChangeStatusPortal,
        closePortal: closeChangeStatusPortal,
        isOpen: changeStatusIsOpen,
        Portal: ChangeStatusPortal,
    } = usePortal({
        bindTo: document && document.getElementById('modal-portal'),
        onOpen({ portal }) {
            portal.current.style.cssText = 'display: contents;'
        },
    })

    return (
        <li className="col-section">
            <div className="client-list-name">
                {firstName} {lastName}
                {!!status && <span>: {clientStatusMap[status] ?? status}</span>}
            </div>
            <div className="client-list-buttons">
                <FontAwesomeIcon
                    onClick={(e) => openChangeStatusPortal(e)}
                    icon={faSync}
                    className="client-action"
                    title="Update Status"
                />
                <Link to={`/clients/${id}`}>
                    <FontAwesomeIcon icon={faPen} title="Edit Client" />
                </Link>
                <Link to={`/clients/${id}/presentation`}>
                    <FontAwesomeIcon icon={faSignal} title="Present IPSA" />
                </Link>
                {/* <img src={DeleteIcon} alt="delete" /> */}
                <FontAwesomeIcon
                    icon={faTimes}
                    className="client-list-delete"
                    title="Delete Client"
                    onClick={openDeletePortal}
                    size="lg"
                />
            </div>

            {deletePortalIsOpen && (
                <DeletePortal className="class-here">
                    <DeleteClientModal
                        refreshList={refreshList}
                        close={closeDeletePortal}
                        firstName={firstName}
                        lastName={lastName}
                        clientId={id}
                    ></DeleteClientModal>
                </DeletePortal>
            )}

            {changeStatusIsOpen && (
                <ChangeStatusPortal className="class-here">
                    <ChangeStatusModal
                        refreshList={refreshList}
                        close={closeChangeStatusPortal}
                        firstName={firstName}
                        lastName={lastName}
                        clientId={id}
                        nextStatuses={nextStatuses}
                    />
                </ChangeStatusPortal>
            )}
        </li>
    )
}

export default ClientDisplay
